/* eslint-disable */
import type React from 'react';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';
import type { Action } from '../../../contexts/reducers/map-reducer';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';

import type { Dealer } from '../../../models/dealer';
import mapContext from '../../../contexts/map-context';

export enum Direction {
  In,
  Out,
}

const dispatchHoverActionByDirection = (
  dispatch: React.Dispatch<Action>,
  direction: Direction,
  dealer?: Dealer,
) => {
  switch (direction) {
    case Direction.In:
      dispatch({ type: ActionTypes.setHoveredDealer, payload: dealer });
      break;

    case Direction.Out:
      dispatch({ type: ActionTypes.setHoveredDealer, payload: null });
      break;

    default:
      break;
  }
};

export const handleHover = (direction: Direction, dealer?: Dealer) => {
  const isMobileScreen = useIsMobileScreen();
  const dispatch = mapContext.useMapDispatch();

  return () => {
    if (!isMobileScreen) {
      dispatchHoverActionByDirection(dispatch, direction, dealer);
    }
  };
};
